import { BasicRequest } from "./basicRequest";

export class DeleteVendorRequest extends BasicRequest{

    public vendorId! : number;
    public physicalDelete : boolean = false;

    constructor(){
        super();
    }
}